import { css } from '@emotion/react';

const typography = {
  heading1: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 600;
    font-size: 20px;
    letter-spacing: -0.03em;
  `,
  uploadBtn: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 700;
    font-size: 18px;
    letter-spacing: -0.03em;
  `,
  loginInput: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: -0.03em;
  `,
  body1M: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: -0.03em;
  `,
  body1S: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 600;
    font-size: 18px;
    letter-spacing: -0.03em;
  `,
  body1B: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 700;
    font-size: 18px;
    letter-spacing: -0.03em;
  `,
  body2M: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: -0.03em;
  `,
  body2R: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.03em;
  `,
  body3R: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: -0.03em;
  `,
  body3M: css`
    font-family: 'Pretendard', sans-serif;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: -0.03em;
  `,
};

export default typography;
